import { isType } from '@spotify/confidence-graphql';
import { createCollectionEntryExtension } from '@spotify/plugin-confidence-collections-react';
import {
  collectionEntryMetricFieldsFragment,
  getMetricFactTable,
  getMetricState,
  metricRouteRef,
} from '@spotify/plugin-confidence-metrics-react';

import { metricsPlugin } from '../plugin';

export const MetricCollectionEntryExtension = metricsPlugin.provide(
  createCollectionEntryExtension({
    id: 'metric',
    resourceType: 'Metric',
    routeRef: metricRouteRef,
    fragment: collectionEntryMetricFieldsFragment,
    predicate: ({ resource }) => isType(resource, 'MetricsV1Metric'),
    render: () => null,
    columns: [
      { id: 'state', getValue: getMetricState },
      { id: 'factTable', getValue: getMetricFactTable },
    ],
  }),
);
